import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Avatar from 'antd/lib/avatar'
import { getInitials } from '../../../lib/helpers'
import Popover from 'antd/lib/popover'
import history from '../../../History'
import { Auth } from 'aws-amplify'
import { StorageService } from '../../../lib/StorageService'
import '../../../styles/UserAvatarPopover.css'
import Menu from 'antd/lib/menu'
import Icon from 'antd/lib/icon'

const styles = {
    container: {
        color: '#000000',
        cursor: 'pointer',
        float: 'right',
        margin: '15px',
    },
}

function UserAvatar({ containerStyle }) {
    const user = useSelector((state) => state.app.user)
    const [visible, setVisible] = useState(false)
    const { firstName, lastName } = user
    const logout = () => {
        Auth.signOut()
            .then(() => window.location.replace('/'))
            .catch((err) => console.log(err))
        StorageService.clearData()
    }
    const handleClickChange = (visible) => {
        setVisible(visible)
    }
    const settings = () => {
        history.push('/profile')
        setVisible(!visible)
    }
    const content = (
        <Menu selectedKeys={[]}>
            <Menu.Item onClick={() => settings()} key="1">
                <Icon type="setting" theme="outlined" />
                User Profile
            </Menu.Item>
            <Menu.Item onClick={() => logout()} key="2">
                <Icon type="logout" theme="outlined" />
                Logout
            </Menu.Item>
        </Menu>
    )

    // Safely get initials, handling null/undefined values
    const getAvatarInitials = () => {
        if (!firstName && !lastName) return '?'
        const first = firstName || ''
        const last = lastName || ''
        const fullName = `${first} ${last}`.trim()
        return fullName ? getInitials(fullName.toUpperCase()) : '?'
    }

    return (
        <Popover
            content={content}
            placement="bottomRight"
            trigger="click"
            visible={visible}
            onVisibleChange={handleClickChange}
        >
            <Avatar style={containerStyle ? containerStyle : styles.container}>
                {getAvatarInitials()}
            </Avatar>
        </Popover>
    )
}

export default UserAvatar
